import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule, RouterOutlet } from '@angular/router';
import { doc, Firestore, setDoc } from '@angular/fire/firestore';
import { Observable, Subscription } from 'rxjs';
import { AdminAuthComponent } from '../../auth/admin-auth-component/admin-auth-component';
import { Tournament } from '../shared/tournament';
import { TournamentCategory } from '../shared/tournament-category';
import { OpenSquashService } from '../shared/services/open-squash-service';

@Component({
  selector: 'app-open10-component',
  imports: [RouterModule, RouterOutlet, CommonModule, MatButtonModule],
  templateUrl: './open10-component.html',
  styleUrl: './open10-component.scss',
})
export class Open10Component {
  private openSquashService = inject(OpenSquashService);
  private dialog = inject(MatDialog);
  private firestore = inject(Firestore);

  torneoCreado = true;

  tournament!: Tournament;
  categories: TournamentCategory[] = [];
  esAdmin$!: Observable<boolean>;
  tournamentSubscription!: Subscription;

  ngOnInit(): void {
    this.esAdmin$ = this.openSquashService.esAdmin$;
    this.openSquashService.setTournament('10open');
    this.tournamentSubscription = this.openSquashService.tournament$.subscribe(
      (tournament) => {
        this.tournament = tournament;
        this.categories = tournament.categories.sort(
          (a, b) => a.categoryOrder - b.categoryOrder
        );
      }
    );
  }

  authAdmin() {
    this.dialog
      .open(AdminAuthComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.openSquashService.setAsAdmin(true);
        }
      });
  }

  logout() {
    this.openSquashService.setAsAdmin(false);
  }

  async crearTorneo() {
    const categorias = [
      'primera', 'segunda', 'tercera', 'cuarta',
      'quinta', 'sexta', 'novatos', 'damas', 'juvenil'
    ];

    const tournament = {
      name: 'Décimo Open Squash',
      categories: categorias.map((cat, i) => ({
        category: cat,
        categoryOrder: i + 1,
        groups: [{ name: 'A', players: [] }],
        players: [],
        finals: {},
        hasQuarterFinals: false,
        hasSemiFinals: false,
        hasFinal: false,
      })),
    };

    const ref = doc(this.firestore, 'tournament/10open');
    await setDoc(ref, tournament);
    this.torneoCreado = true;
    console.log('Torneo 10open creado en Firestore');
    // Recargar datos del torneo
    this.openSquashService.setTournament('10open');
    this.tournamentSubscription = this.openSquashService.tournament$.subscribe(
      (tournament) => {
        this.tournament = tournament;
        this.categories = tournament.categories.sort(
          (a, b) => a.categoryOrder - b.categoryOrder
        );
      }
    );
  }

  ngOnDestroy(): void {
    this.tournamentSubscription.unsubscribe();
  }
}
